module.exports = __webpack_public_path__ + "img/1390335348.53ef70c2.jpg";